/* BeyondADS lucky spin - carbon-fibre wheel */
(function () {
  var dataEl = document.getElementById('bdsw-data');
  var root = document.querySelector('[data-bdsw]');
  if (!dataEl || !root) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P = (D.prizes || []).filter(function (p) { return p.weight > 0; });
  if (!P.length) return;
  // one prize left -> repeat it on every slice so the wheel still looks like a wheel (every slice really pays it)
  if (P.length === 1) P = [P[0], P[0], P[0], P[0], P[0], P[0]];

  document.body.appendChild(root); // escape any transformed parent
  var chip = document.querySelector('[data-bdsw-chip]');
  if (chip) document.body.appendChild(chip);

  // K_SEEN: closed during this visit | K_NEXT: no auto-open before this time (repeatDays) | K_SPUN: spun this visit | K_EXIT: exit re-show used
  var K_SEEN = 'bdswSeen', K_PRIZE = 'bdswPrize', K_NEXT = 'bdswNext', K_SPUN = 'bdswSpun', K_EXIT = 'bdswExit';
  var DAYS = D.repeatDays > 0 ? D.repeatDays : 15;
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }

  var $ = function (s) { return root.querySelector(s); };
  var rotor = $('[data-bdsw-rotor]'), btn = $('[data-bdsw-spin]'), pre = $('[data-bdsw-pre]'), win = $('[data-bdsw-win]');

  /* ---------- build the carbon wheel (SVG) ---------- */
  var N = P.length, SEG = 360 / N, R = 200;
  function pt(r, deg) { var a = (deg - 90) * Math.PI / 180; return [(r * Math.cos(a)).toFixed(2), (r * Math.sin(a)).toFixed(2)]; }
  function weave(id, dark, mid, light) {
    // 2x2 twill-look tow pattern, rotated 45deg like a real carbon sheet
    return '<linearGradient id="' + id + 'h" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + dark + '"/><stop offset=".5" stop-color="' + light + '"/><stop offset="1" stop-color="' + dark + '"/></linearGradient>' +
      '<linearGradient id="' + id + 'v" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="' + dark + '"/><stop offset=".5" stop-color="' + mid + '"/><stop offset="1" stop-color="' + dark + '"/></linearGradient>' +
      '<pattern id="' + id + '" width="14" height="14" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">' +
      '<rect width="14" height="14" fill="' + dark + '"/>' +
      '<rect x=".4" y=".4" width="6.2" height="6.2" rx="1" fill="url(#' + id + 'h)"/><rect x="7.4" y="7.4" width="6.2" height="6.2" rx="1" fill="url(#' + id + 'h)"/>' +
      '<rect x="7.4" y=".4" width="6.2" height="6.2" rx="1" fill="url(#' + id + 'v)"/><rect x=".4" y="7.4" width="6.2" height="6.2" rx="1" fill="url(#' + id + 'v)"/>' +
      '</pattern>';
  }
  var svg = '<svg viewBox="-200 -200 400 400" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><defs>' +
    weave('bdswK', '#070707', '#262626', '#3d3d3d') +
    weave('bdswR', '#3a0005', '#8f0010', '#d0101e') +
    '<radialGradient id="bdswBolt" cx=".35" cy=".35" r=".7"><stop offset="0" stop-color="#fff"/><stop offset=".55" stop-color="#bdbdbd"/><stop offset="1" stop-color="#5b5b5b"/></radialGradient>' +
    '<radialGradient id="bdswShade" cx="0" cy="0" r="200" gradientUnits="userSpaceOnUse"><stop offset=".55" stop-color="#000" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".45"/></radialGradient>' +
    '</defs>';
  for (var i = 0; i < N; i++) {
    var a0 = i * SEG, a1 = (i + 1) * SEG, p0 = pt(R, a0), p1 = pt(R, a1);
    svg += '<path d="M0 0 L' + p0[0] + ' ' + p0[1] + ' A' + R + ' ' + R + ' 0 ' + (SEG > 180 ? 1 : 0) + ' 1 ' + p1[0] + ' ' + p1[1] + ' Z" fill="url(#' + (i % 2 ? 'bdswR' : 'bdswK') + ')"/>';
  }
  svg += '<circle r="200" fill="url(#bdswShade)"/>';
  for (i = 0; i < N; i++) { // brushed-metal seams between slices
    var s = pt(R, i * SEG);
    svg += '<line x1="0" y1="0" x2="' + s[0] + '" y2="' + s[1] + '" stroke="#d9d9d9" stroke-opacity=".55" stroke-width="1.6"/>';
  }
  for (i = 0; i < N; i++) { // labels, upright along each slice
    var mid = i * SEG + SEG / 2, p = P[i];
    var small = String(p.bottom || ''), long = small.length > 10;
    svg += '<g transform="rotate(' + mid + ')">' +
      '<text x="0" y="-128" text-anchor="middle" font-family="Barlow Condensed, Bebas Neue, Arial, sans-serif" font-weight="800" font-size="' + (String(p.top).length > 4 ? 32 : 40) + '" fill="#fff" style="paint-order:stroke" stroke="rgba(0,0,0,.35)" stroke-width="2">' + esc(p.top) + '</text>' +
      '<text x="0" y="-104" text-anchor="middle" font-family="Barlow Condensed, Bebas Neue, Arial, sans-serif" font-weight="700" font-size="' + (long ? 12.5 : 16) + '" letter-spacing="1.2" fill="#fff" fill-opacity=".92">' + esc(small) + '</text>' +
      '</g>';
  }
  for (i = 0; i < 12; i++) { // rim bolts
    var b = pt(186, i * 30 + 15);
    svg += '<circle cx="' + b[0] + '" cy="' + b[1] + '" r="4.2" fill="url(#bdswBolt)" stroke="#2a2a2a" stroke-width=".8"/>';
  }
  svg += '</svg>';
  rotor.innerHTML = svg;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- open / close ---------- */
  var lastFocus = null, closedAt = 0;
  function blockFor() { ls(K_NEXT, String(Date.now() + DAYS * 86400000)); } // the same browser will not get it again for DAYS days
  function blocked() { return Number(ls(K_NEXT) || 0) > Date.now(); }
  var dlg = $('.bdsw__dialog');
  // allow scrolling only if the dialog is genuinely taller than the screen (small phones); measured at rest, never mid-spin
  function fit() {
    if (root.hidden || spinning) return;
    dlg.classList.remove('is-scroll');
    if (dlg.scrollHeight - dlg.clientHeight > 24) dlg.classList.add('is-scroll');
  }
  window.addEventListener('resize', fit);
  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('bdsw-lock');
    void root.offsetWidth;
    root.classList.add('is-in');
    fit();
    setTimeout(function () { try { $('.bdsw__dialog').focus({ preventScroll: true }); } catch (e) {} }, 50); // focus the dialog, not a button (no ring on open)
  }
  function close() {
    root.classList.remove('is-in');
    document.documentElement.classList.remove('bdsw-lock');
    ss(K_SEEN, '1');
    closedAt = Date.now();
    setTimeout(function () { root.hidden = true; }, 380);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    paintChip();
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-bdsw-close]') && !root.classList.contains('is-spinning')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden && !root.classList.contains('is-spinning')) close(); });

  /* ---------- prize state (localStorage, survives page changes) ---------- */
  function readPrize() { try { return JSON.parse(ls(K_PRIZE) || 'null'); } catch (e) { return null; } }
  function livePrize() { var w = readPrize(); return w && w.until > Date.now() ? w : null; }
  // expired reward: shown as "Oops, you missed the opportunity" for the rest of the visit in which it ran out, then forgotten
  var SID = ss('bdswSid') || (function () { var v = String(Math.random()).slice(2); ss('bdswSid', v); return v; })();
  function missedPrize() {
    var w = readPrize();
    if (!w || w.until > Date.now()) return null;
    if (!w.ms) { w.ms = SID; ls(K_PRIZE, JSON.stringify(w)); }
    if (w.ms !== SID) { ls(K_PRIZE, null); return null; }
    return w;
  }
  // winner never types the code: it goes straight onto the cart (other codes the customer added stay)
  function cartCodes() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { return (c.discount_codes || []).map(function (d) { return d.code; }); });
  }
  function setCodes(list) {
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: list.join(',') }) });
  }
  var lastApply = 0;
  function applyCode(w) {
    if (!w || !w.code || !window.fetch) return;
    lastApply = Date.now();
    cartCodes().then(function (codes) {
      var has = codes.some(function (k) { return String(k).toUpperCase() === String(w.code).toUpperCase(); });
      if (!has && livePrize()) return setCodes(codes.concat(w.code));
    }).catch(function () {});
  }
  // the code stops working on this cart: drop it from the cart's discount codes if it was applied there (other codes stay)
  function expireCode(w) {
    if (!w || !w.code || w.cleared || !window.fetch) return;
    w.cleared = 1; ls(K_PRIZE, JSON.stringify(w));
    cartCodes().then(function (codes) {
      var keep = codes.filter(function (k) { return String(k).toUpperCase() !== String(w.code).toUpperCase(); });
      if (keep.length !== codes.length) return setCodes(keep);
    }).catch(function () {});
  }
  function label(p) { return (p.top + ' ' + (p.bottom || '')).trim(); }
  function mmss(ms) { var s = Math.max(0, Math.ceil(ms / 1000)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }

  var TXT = D.txt || {};
  var URGENT = (D.urgentMin || 5) * 60000;
  function fill(t, w) {
    return String(t || '').replace(/\{minutes\}/g, D.minutes || 15).replace(/\{prize\}/g, w.label).replace(/\{code\}/g, w.code || '').replace(/\s+([.,])/g, '$1').trim();
  }

  var screen = '';
  function showWin(w) {
    screen = 'win';
    pre.hidden = true; win.hidden = false;
    win.classList.remove('is-lose');
    $('[data-bdsw-wineye]').textContent = 'You won';
    $('[data-bdsw-prize]').textContent = w.label;
    $('[data-bdsw-note]').textContent = w.note || '';
    $('.bdsw__code').hidden = true; // the code is applied for them, never shown
    $('[data-bdsw-applied]').hidden = !w.code;
    $('[data-bdsw-count]').hidden = false;
    $('[data-bdsw-winmsg]').textContent = fill(TXT.winMsg, w);
    startClock();
    fit();
  }
  // "Better luck next time" slice: a kind message only - nothing is saved, no code, no timer, no cart strip
  function showLose() {
    screen = 'lose';
    pre.hidden = true; win.hidden = false;
    win.classList.add('is-lose');
    $('[data-bdsw-wineye]').textContent = TXT.loseEyebrow || 'So close';
    $('[data-bdsw-prize]').textContent = TXT.loseTitle || 'Better luck next time';
    $('[data-bdsw-note]').textContent = TXT.loseMsg || '';
    $('.bdsw__code').hidden = true;
    $('[data-bdsw-applied]').hidden = true;
    $('[data-bdsw-count]').hidden = true;
    fit();
  }
  // the reserved minutes ran out while the win screen is open
  function showMissed(w) {
    screen = 'missed';
    pre.hidden = true; win.hidden = false;
    win.classList.add('is-lose');
    $('[data-bdsw-wineye]').textContent = TXT.missEyebrow || "Time's up";
    $('[data-bdsw-prize]').textContent = TXT.missTitle || 'Oops, you missed the opportunity.';
    $('[data-bdsw-note]').textContent = fill(TXT.missText, w);
    $('.bdsw__code').hidden = true;
    $('[data-bdsw-applied]').hidden = true;
    $('[data-bdsw-count]').hidden = true;
    fit();
  }

  /* ---------- countdown: MM:SS:hundredths, one loop drives the popup + every cart-drawer strip ---------- */
  function fmtCs(ms) {
    var cs = Math.max(0, Math.floor(ms / 10));
    var m = Math.floor(cs / 6000), sec = Math.floor(cs / 100) % 60, h = cs % 100;
    return ('0' + m).slice(-2) + ':' + ('0' + sec).slice(-2) + ':' + ('0' + h).slice(-2);
  }
  var running = false, lastUrgent = null;
  function paintClock() {
    var w = livePrize();
    if (!w) { if (running) stopClock(); return; }
    var left = w.until - Date.now(), txt = fmtCs(left), urgent = left <= URGENT;
    var els = document.querySelectorAll('[data-bdsw-cs]');
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== txt) els[i].textContent = txt; // compare before write
    if (urgent !== lastUrgent) {
      lastUrgent = urgent;
      var u = document.querySelectorAll('.bdsw__clock, .bdsw-dt');
      for (i = 0; i < u.length; i++) u[i].classList.toggle('is-urgent', urgent);
    }
  }
  function frame() { if (!running) return; paintClock(); requestAnimationFrame(frame); }
  var safetyT = null;
  function startClock() {
    ensureStrips();
    lastUrgent = null;
    paintClock();
    if (running) return;
    running = true;
    requestAnimationFrame(frame);
    // rAF is frozen in a background tab: keep the numbers honest with a slower timer too
    safetyT = setInterval(function () { paintClock(); paintChip(); }, 250);
  }
  function stopClock() {
    running = false;
    clearInterval(safetyT);
    var els = document.querySelectorAll('[data-bdsw-cs]');
    for (var i = 0; i < els.length; i++) els[i].textContent = '00:00:00';
    removeStrips();
    paintChip();
    showMissedEverywhere();
  }
  function showMissedEverywhere() {
    var w = missedPrize();
    if (!w) return;
    expireCode(w);
    ensureStrips();
    if (!root.hidden && screen === 'win') showMissed(w);
  }

  /* ---------- cart drawer strip: shown whenever a reward is live (empty cart or not) ---------- */
  function stripHtml(w, where) {
    return '<div class="bdsw-dt bdsw-dt--' + where + '" data-bdsw-dt>' +
      '<span class="bdsw-dt__ico" aria-hidden="true">&#127873;</span>' +
      '<span class="bdsw-dt__txt"><b class="n">' + esc(fill(TXT.drTitle, w)) + '</b><span class="n">' + esc(fill(TXT.drText, w)) + '</span>' +
      '<b class="u">' + esc(fill(TXT.drUrgTitle, w)) + '</b><span class="u">' + esc(fill(TXT.drUrgText, w)) + '</span></span>' +
      '<b class="bdsw-dt__clock" data-bdsw-cs>' + fmtCs(w.until - Date.now()) + '</b></div>';
  }
  function missedHtml(w, where) {
    return '<div class="bdsw-dt bdsw-dt--' + where + ' is-missed" data-bdsw-dt data-bdsw-missed>' +
      '<span class="bdsw-dt__ico" aria-hidden="true">&#9201;</span>' +
      '<span class="bdsw-dt__txt"><b>' + esc(TXT.missTitle || 'Oops, you missed the opportunity.') + '</b><span>' + esc(fill(TXT.missText, w)) + '</span></span></div>';
  }
  function ensureStrips() {
    var w = livePrize(), miss = !w && missedPrize();
    if (!w && !miss) return;
    if (miss) {
      var live = document.querySelectorAll('[data-bdsw-dt]:not([data-bdsw-missed])');
      for (var k = 0; k < live.length; k++) live[k].remove();
    }
    var make = miss ? missedHtml : stripHtml, ww = w || miss;
    var drawers = document.querySelectorAll('cart-drawer, #CartDrawer');
    for (var i = 0; i < drawers.length; i++) {
      var d = drawers[i];
      var head = d.querySelector('.drawer__header');
      if (head && !d.querySelector('.bdsw-dt--items')) head.insertAdjacentHTML('afterend', make(ww, 'items'));
      var empty = d.querySelector('.cart-drawer__warnings') || d.querySelector('.drawer__inner-empty');
      if (empty && !d.querySelector('.bdsw-dt--empty')) empty.insertAdjacentHTML('afterbegin', make(ww, 'empty'));
    }
    lastUrgent = null; // new strips pick up the current colour on the next paint
  }
  function removeStrips() {
    var s = document.querySelectorAll('[data-bdsw-dt]');
    for (var i = 0; i < s.length; i++) s[i].remove();
  }
  // the theme re-renders the drawer on every cart change: put the strip back (debounced, insert-only so it cannot loop)
  if (window.MutationObserver) {
    var dq = false;
    var mo = new MutationObserver(function () {
      if (dq) return; dq = true;
      setTimeout(function () {
        dq = false;
        var lw = livePrize();
        if (lw) { ensureStrips(); paintClock(); if (Date.now() - lastApply > 10000) applyCode(lw); } // cart changed: make sure the code is still on it (max every 10 s)
        else if (missedPrize()) ensureStrips();
      }, 30);
    });
    var drs = document.querySelectorAll('cart-drawer');
    for (var di = 0; di < drs.length; di++) mo.observe(drs[di], { childList: true, subtree: true });
  }

  function paintChip() {
    if (!chip) return;
    var w = livePrize();
    if (!w) { chip.hidden = true; return; }
    chip.hidden = false;
    chip.querySelector('[data-bdsw-chip-prize]').textContent = w.label;
    var t = mmss(w.until - Date.now()) + ' left', el = chip.querySelector('[data-bdsw-chip-clock]');
    if (el.textContent !== t) el.textContent = t;
  }
  if (chip) chip.addEventListener('click', function () { var w = livePrize(); if (w) { showWin(w); open(); } });


  /* ---------- the spin ---------- */
  function pick() {
    var total = P.reduce(function (s, p) { return s + p.weight; }, 0), r = Math.random() * total;
    for (var i = 0; i < P.length; i++) { r -= P[i].weight; if (r < 0) return i; }
    return P.length - 1;
  }

  function copyCode(code, b) {
    function done() { b.textContent = 'Copied!'; setTimeout(function () { b.textContent = 'Copy'; }, 1800); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback); else fallback();
    function fallback() {
      var t = document.createElement('textarea'); t.value = code; t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select(); try { document.execCommand('copy'); done(); } catch (e) {} t.remove();
    }
  }
  $('[data-bdsw-copy]').addEventListener('click', function () { var w = livePrize(); if (w && w.code) copyCode(w.code, this); });

  function confetti() {
    var box = $('[data-bdsw-confetti]'), cols = ['#ff2a36', '#ffffff', '#9a9a9a', '#d1000f', '#3d3d3d'], html = '';
    for (var i = 0; i < 34; i++) {
      html += '<i style="left:' + (Math.random() * 100).toFixed(1) + '%;background:' + cols[i % cols.length] +
        ';--x:' + Math.round(Math.random() * 160 - 80) + 'px;--r:' + Math.round(Math.random() * 720 - 360) + 'deg;--d:' + (1.8 + Math.random() * 1.4).toFixed(2) + 's;--w:' + (Math.random() * .35).toFixed(2) + 's"></i>';
    }
    box.innerHTML = html;
    setTimeout(function () { box.innerHTML = ''; }, 3600);
  }

  var spinning = false, angle = 0;
  function spin() {
    if (spinning) return;
    spinning = true;
    btn.disabled = true;
    root.classList.add('is-spinning');
    var idx = pick();
    var center = idx * SEG + SEG / 2;
    var jitter = (Math.random() - .5) * (SEG - 14); // land inside the slice, never on a seam
    var target = angle - (angle % 360) + 360 * 6 + (360 - center) + jitter;
    var DUR = 5200;
    // pin the start angle with no transition, then animate on a later tick (rAF can be frozen in a background tab)
    rotor.style.transition = 'none';
    rotor.style.transform = 'rotate(' + angle + 'deg)';
    void rotor.offsetWidth;
    setTimeout(function () {
      rotor.style.transition = 'transform ' + DUR + 'ms cubic-bezier(.12,.62,.08,1)';
      rotor.style.transform = 'rotate(' + target + 'deg)';
    }, 30);
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      angle = target;
      spinning = false;
      root.classList.remove('is-spinning');
      var p = P[idx];
      ss(K_SEEN, '1'); ss(K_SPUN, '1');
      blockFor();
      if (!p.code) { showLose(); return; } // no-prize slice
      var w = { label: label(p), note: p.note, code: p.code, until: Date.now() + (D.minutes || 15) * 60000 };
      ls(K_PRIZE, JSON.stringify(w));
      applyCode(w);
      showWin(w);
      confetti();
    }
    rotor.addEventListener('transitionend', function te(e) { if (e.propertyName === 'transform') { rotor.removeEventListener('transitionend', te); finish(); } });
    setTimeout(finish, DUR + 400);
  }
  btn.addEventListener('click', spin);

  /* ---------- auto-open: N s after landing, then not again for DAYS days; never while a reward is running ---------- */
  paintChip();
  if (livePrize()) { applyCode(livePrize()); startClock(); return; } // reward still running from an earlier page: keep it on the cart + the drawer timer going
  showMissedEverywhere(); // it ran out on another page or while they were away
  if (window.Shopify && Shopify.designMode) return; // not inside the theme editor
  function autoOpen() {
    if (livePrize() || ss(K_SEEN) || blocked() || !root.hidden) return;
    blockFor(); // counted as seen the moment it shows
    open();
  }
  if (!ss(K_SEEN) && !blocked()) {
    var wait = Math.max(0, (D.delay || 3000) - ((window.performance && performance.now) ? performance.now() : 0));
    setTimeout(autoOpen, wait);
  }

  /* ---------- exit intent: closed it without spinning on this visit -> one more look as they try to leave ---------- */
  if (D.exitIntent === false) return;
  function exitReady() {
    if (!root.hidden || spinning || livePrize() || ss(K_SPUN) || ss(K_EXIT)) return false;
    if (ss(K_SEEN)) return Date.now() - closedAt > 4000 || !closedAt; // closed earlier in this visit (give them 4 s after closing)
    return !blocked(); // leaving before the timed popup appeared
  }
  function onExit() {
    if (!exitReady()) return;
    ss(K_EXIT, '1');
    blockFor();
    pre.hidden = false; win.hidden = true; btn.disabled = false;
    open();
  }
  // desktop: the pointer leaves through the top of the window (towards the tabs / address bar / close)
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0) onExit();
  });
  // phones: a fast swipe back up after reading (heading for the address bar), or coming back to the tab after leaving it
  var lastY = window.pageYOffset, lastT = Date.now(), maxY = lastY;
  window.addEventListener('scroll', function () {
    var y = window.pageYOffset, t = Date.now(), dt = t - lastT;
    if (y > maxY) maxY = y;
    if (dt > 0 && dt < 250 && lastY - y > 0) {
      var v = (lastY - y) / dt; // px per ms, upwards
      if (v > 2.2 && maxY > 600 && window.matchMedia('(hover: none)').matches) onExit();
    }
    lastY = y; lastT = t;
  }, { passive: true });
  var hiddenAt = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { hiddenAt = Date.now(); return; }
    if (hiddenAt && Date.now() - hiddenAt > 1500) setTimeout(onExit, 600);
  });
})();
